
<template>
    <router-view class="app"></router-view>
</template>

<script>
  export default {
    
  }
</script>
